export default __webpack_public_path__ + "static/media/urli.95484fbc.jpg";